import React from "react";
import { Link } from "react-router-dom";
import { FaCalendarAlt, FaUser, FaClock, FaChevronLeft, FaShare, FaLinkedin, FaTwitter, FaFacebook } from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DetailBlog2 = () => {
    // Données du blog avec le contenu sur la digitalisation fiscale
    const blogPost = {
        id: 3,
        title: "Digitalisation fiscale au Bénin : maîtrisez la plateforme e-Services et sécurisez votre entreprise",
        excerpt: "La fin du papier, le début de l'efficacité. L'époque des longues files d'attente aux guichets des impôts et des déclarations papier est en train de se terminer au Bénin. Découvrez comment maîtriser e-Services et transformer cette obligation en avantage concurrentiel.",
        content: `
      <p class="lead">La fin du papier, le début de l'efficacité</p>
      
      <p>L'époque des longues files d'attente aux guichets des impôts et des déclarations papier est en train de se terminer au Bénin. La transformation numérique de l'administration fiscale est en marche, avec en son cœur un outil désormais incontournable pour toute entreprise : la plateforme e-Services.</p>
      
      <p>Loin d'être un simple gadget technologique, cette plateforme modifie en profondeur la manière dont vous gérez vos obligations fiscales. La maîtriser n'est plus une option, c'est une nécessité pour garantir votre conformité, gagner un temps précieux et éviter des erreurs coûteuses.</p>
      
      <p>Ce guide pratique vous explique comment tirer le meilleur parti de la digitalisation et comment votre expert-comptable devient votre co-pilote dans cet univers numérique.</p>
      
      <h3>1. Les avantages concrets de e-Services : Gain de temps et traçabilité</h3>
      <p>La plateforme e-Services centralise deux fonctions vitales pour votre entreprise : la télédéclaration et le télépaiement.</p>
      
      <h4>Ce que cela signifie pour vous :</h4>
      <ul>
        <li><strong>Disponibilité 24/7 :</strong> Vous pouvez effectuer vos déclarations (TVA, AIB, etc.) et vos paiements à tout moment et de n'importe où, sans vous soucier des heures d'ouverture des bureaux.</li>
        <li><strong>Gain de temps et d'argent :</strong> Finis les déplacements, les frais de transport et les heures perdues dans les formalités administratives.</li>
        <li><strong>Sécurité et traçabilité :</strong> Chaque transaction génère une quittance dématérialisée, un document électronique qui constitue une preuve de paiement fiable et infalsifiable. De plus, la plateforme conserve un historique de toutes vos soumissions, offrant une visibilité claire sur votre situation fiscale.</li>
      </ul>
      
      <blockquote>
        Notre conseil : Adoptez le réflexe e-Services pour toutes vos obligations déclaratives. La simplicité d'utilisation et la sécurité des transactions en font un allié majeur de votre gestion quotidienne.
      </blockquote>
      
      <h3 class="errors-section-title">2. Les 3 erreurs courantes sur e-Services et comment les éviter</h3>
      <p>Si l'outil est performant, son utilisation requiert de la rigueur. De nouvelles habitudes doivent être prises pour éviter les pièges du numérique.</p>
      
      <div class="error-card">
        <h4><span class="error-number">Erreur n°1</span> Attendre la dernière minute</h4>
        <p>Comme toute plateforme en ligne, e-Services peut connaître des pics de fréquentation, notamment à l'approche des dates limites. Un bug de votre ordinateur ou une coupure internet de dernière minute peut vous mettre en situation de retard de déclaration, et donc vous exposer à des pénalités.</p>
        <p class="solution"><strong>La solution :</strong> Anticipez ! Fixez-vous comme objectif de réaliser vos déclarations et paiements au moins 48 heures avant la date butoir.</p>
      </div>
      
      <div class="error-card">
        <h4><span class="error-number">Erreur n°2</span> Déclarer sans vérifier la cohérence comptable</h4>
        <p>La facilité de la saisie en ligne peut parfois conduire à des erreurs d'inattention ou à des incohérences avec votre comptabilité réelle. Or, l'administration fiscale peut facilement croiser les données que vous déclarez avec celles des années précédentes ou celles de vos partenaires.</p>
        <p class="solution"><strong>La solution :</strong> Ne considérez jamais la déclaration comme une tâche isolée. Elle doit être le reflet exact de votre comptabilité. Faites systématiquement valider les montants par votre expert-comptable avant de cliquer sur "Soumettre".</p>
      </div>
      
      <div class="error-card">
        <h4><span class="error-number">Erreur n°3</span> Confondre la plateforme et une archive légale</h4>
        <p>e-Services garde un historique de vos dépôts, mais ne constitue pas un système d'archivage à valeur probante au sens de la loi. En cas de contrôle, vous devez être capable de fournir non seulement la déclaration, mais aussi toutes les pièces justificatives qui y sont liées (factures, etc.).</p>
        <p class="solution"><strong>La solution :</strong> Mettez en place une politique d'archivage numérique sécurisée en interne. Chaque déclaration soumise sur e-Services et chaque quittance reçue doivent être téléchargées et classées méthodiquement sur vos serveurs ou un cloud sécurisé, avec les pièces comptables correspondantes.</p>
      </div>
      
      <h3>3. Votre expert-comptable : Votre allié dans la transition numérique</h3>
      <p>Face à ces changements, le rôle de votre expert-comptable évolue. Nous ne sommes plus seulement là pour tenir les comptes, mais pour garantir la fluidité et la sécurité de vos interactions avec l'administration fiscale.</p>
      
      <ul>
        <li><strong>Gestion déléguée :</strong> Nous pouvons prendre en charge l'intégralité du processus de télédéclaration et de télépaiement pour votre compte, vous libérant ainsi l'esprit pour vous concentrer sur votre cœur de métier.</li>
        <li><strong>Vérification et conformité :</strong> Nous assurons la cohérence et l'exactitude des informations transmises, minimisant ainsi le risque de redressement.</li>
        <li><strong>Conseil en archivage :</strong> Nous vous aidons à mettre en place le système d'archivage numérique qui répond aux exigences légales et garantit la pérennité de vos documents.</li>
        <li><strong>Intermédiaire de confiance :</strong> En cas de question ou de blocage sur la plateforme, nous servons d'interlocuteur technique et administratif avec les services des impôts.</li>
      </ul>
      
      <h3>Faites du numérique un avantage concurrentiel</h3>
      <p>La digitalisation fiscale au Bénin est une évolution positive qui vise à simplifier la vie des entreprises. En adoptant les bons réflexes et en vous appuyant sur l'expertise de professionnels, vous transformez cette obligation réglementaire en un véritable outil de pilotage efficace et sécurisé pour votre entreprise.</p>
      
      <h3 style={{ fontSize: '1rem', fontWeight: 'bold' }}>Vous souhaitez sécuriser votre transition numérique et vous assurer que vos pratiques fiscales sont parfaitement conformes ? Contactez notre cabinet. Nous sommes prêts à vous accompagner.</h3>
    `,
        image: "/assets/images/image8.png",
        categories: ["Fiscalité", "Digital", "Conformité"],
        tags: ["e-Services", "Digitalisation", "Fiscalité", "Télédéclaration", "Bénin", "Optimisation"],
        date: "22 Septembre 2025",
        author: "Expert CINEF-EC",
        authorTitle: "Expert-Comptable spécialisé en fiscalité digitale",
        readTime: "6 min",
        featured: true
    };

    // Articles similaires
    const similarBlogs = [
        {
            id: 1,
            title: "Votre guide pour saisir les opportunités au Bénin : L'âge d'or des PME",
            image: "/assets/images/image1.png",
            date: "25 août 2025",
            category: "Développement"
        },
        {
            id: 2,
            title: "Maîtrisez-vous le nouveau système comptable des entités à but non lucratif (SYSCEBNL) ?",
            image: "/assets/images/syscebnl-cover.jpg",
            date: "22 septembre 2025",
            category: "Comptabilité"
        }
    ];

    return (
        <>
            <Header />

            <div className="blog-content py-5">
                <div className="container">
                    {/* Fil d'Ariane */}
                    <nav className="breadcrumb-container mb-4">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/" className="text-decoration-none">Accueil</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/actualites/blog" className="text-decoration-none">Blog</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                {blogPost.title}
                            </li>
                        </ol>
                    </nav>

                    <div className="row">
                        <div className="col-lg-8">
                            {/* Catégorie et Titre */}
                            <div className="blog-header mb-4">
                                <div className="categories-badges mb-2">
                                    {blogPost.categories.map((category, index) => (
                                        <span key={index} className="category-badge me-2">{category}</span>
                                    ))}
                                </div>
                                <h1 className="blog-title">{blogPost.title}</h1>

                                {/* Métadonnées de l'article */}
                                <div className="blog-meta d-flex align-items-center mt-3">
                                    <div className="meta-item d-flex align-items-center">
                                        <FaCalendarAlt className="meta-icon" />
                                        <span>{blogPost.date}</span>
                                    </div>
                                    <div className="meta-item d-flex align-items-center">
                                        <FaUser className="meta-icon" />
                                        <span>{blogPost.author}</span>
                                    </div>
                                    <div className="meta-item d-flex align-items-center">
                                        <FaClock className="meta-icon" />
                                        <span>{blogPost.readTime} de lecture</span>
                                    </div>
                                </div>
                            </div>

                            {/* Image principale */}
                            {/* <div className="blog-featured-image mb-4">
                                <img src={blogPost.image} alt={blogPost.title} className="img-fluid rounded" />
                            </div> */}

                            {/* Extrait de l'article */}
                            <div className="blog-excerpt mb-4">
                                <p className="lead">{blogPost.excerpt}</p>
                            </div>

                            {/* Contenu principal */}
                            <div className="blog-body mb-5" dangerouslySetInnerHTML={{ __html: blogPost.content }} />

                            {/* Tags */}
                            <div className="blog-tags mb-4">
                                {blogPost.tags.map((tag, index) => (
                                    <Link key={index} to={`/tag/${tag}`} className="blog-tag">
                                        #{tag}
                                    </Link>
                                ))}
                            </div>

                            {/* Partage sur les réseaux sociaux */}
                            <div className="blog-share mb-5">
                                <h5 className="share-title">Partager cet article</h5>
                                <div className="social-buttons">
                                    <a href="#" className="social-button linkedin">
                                        <FaLinkedin />
                                    </a>
                                    <a href="#" className="social-button twitter">
                                        <FaTwitter />
                                    </a>
                                    <a href="#" className="social-button facebook">
                                        <FaFacebook />
                                    </a>
                                </div>
                            </div>

                            {/* Bouton Retour */}
                            <div className="blog-actions mb-5">
                                <Link to="/actualites/blog" className="btn btn-back">
                                    <FaChevronLeft className="me-2" /> Retour au blog
                                </Link>
                            </div>
                        </div>

                        {/* Sidebar */}
                        <div className="col-lg-4">
                            {/* À propos de l'auteur */}
                            <div className="sidebar-widget author-widget">
                                <h4 className="widget-title">À propos de l'auteur</h4>
                                <div className="author-profile">
                                    <div className="author-image">
                                        <img src="../assets/images/image5.png" alt={blogPost.author} className="img-fluid rounded-circle" />
                                    </div>
                                    <div className="author-info">
                                        <h5 className="author-name">{blogPost.author}</h5>
                                        <p className="author-title">{blogPost.authorTitle}</p>
                                        <p className="author-bio">Expert-comptable spécialisé dans l'accompagnement des entreprises dans leur transition numérique fiscale et l'optimisation de leurs processus déclaratifs.</p>
                                    </div>
                                </div>
                            </div>

                            {/* Articles similaires */}
                            <div className="sidebar-widget similar-blogs-widget">
                                <h4 className="widget-title">Articles similaires</h4>
                                <div className="similar-blogs">
                                    {similarBlogs.map((similarBlog) => (
                                        <Link key={similarBlog.id} to={`/blog/${similarBlog.id}`} className="similar-blog">
                                            <div className="similar-blog-image">
                                                <img src={similarBlog.image} alt={similarBlog.title} className="img-fluid rounded" />
                                                <span className="category-badge small">{similarBlog.category}</span>
                                            </div>
                                            <div className="similar-blog-content">
                                                <h5 className="similar-blog-title">{similarBlog.title}</h5>
                                                <div className="similar-blog-date">
                                                    <FaCalendarAlt className="me-1" size={12} />
                                                    <small>{similarBlog.date}</small>
                                                </div>
                                            </div>
                                        </Link>
                                    ))}
                                </div>
                            </div>

                            {/* Widget Newsletter */}
                            <div className="sidebar-widget newsletter-widget">
                                <h4 className="widget-title">Newsletter</h4>
                                <p className="newsletter-desc">Recevez nos conseils sur la digitalisation fiscale et les dernières actualités de la dématérialisation au Bénin</p>
                                <form className="newsletter-form">
                                    <div className="form-group mb-3">
                                        <input type="email" className="form-control" placeholder="Votre adresse email" required />
                                    </div>
                                    <button type="submit" className="btn btn-primary w-100">S'abonner</button>
                                </form>
                            </div>

                            {/* Widget Liens utiles */}
                            <div className="sidebar-widget categories-widget">
                                <h4 className="widget-title">Ressources e-Services</h4>
                                <ul className="categories-list">
                                    <li><a href="https://eservices.impots.bj/" target="_blank" rel="noopener noreferrer">Plateforme e-Services <span>→</span></a></li>
                                    <li><a href="#" target="_blank" rel="noopener noreferrer">Guide utilisateur <span>→</span></a></li>
                                    <li><a href="#" target="_blank" rel="noopener noreferrer">Formation télédéclaration <span>→</span></a></li>
                                    <li><Link to="/services/comptabilite-fiscalite">Nos services <span>→</span></Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />

            <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=Merriweather:wght@300;400;700&display=swap');

        /* Styles généraux */
        * {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }

        .blog-content {
          background-color: #fafafa;
        }

        /* Fil d'Ariane */
        .breadcrumb {
          background-color: transparent;
          padding: 0;
          margin-bottom: 0;
          font-size: 0.875rem;
        }

        .breadcrumb-item + .breadcrumb-item::before {
          color: #9ca3af;
        }

        .breadcrumb-item a {
          color: #6b7280;
          text-decoration: none;
          transition: color 0.2s;
        }

        .breadcrumb-item a:hover {
          color: #dc3545;
        }

        .breadcrumb-item.active {
          color: #1f2937;
          font-weight: 500;
        }

        /* En-tête du blog */
        .blog-header {
          margin-bottom: 2.5rem;
        }

        .blog-title {
          font-family: 'Merriweather', Georgia, serif;
          font-size: 2.75rem;
          font-weight: 700;
          margin-bottom: 1.25rem;
          line-height: 1.3;
          color: #111827;
          letter-spacing: -0.02em;
        }

        .category-badge {
          display: inline-block;
          background: #198754;
          color: white;
          padding: 5px 14px;
          border-radius: 20px;
          font-size: 0.75rem;
          font-weight: 600;
          letter-spacing: 0.03em;
          text-transform: uppercase;
        }

        .blog-meta {
          color: #6b7280;
          font-size: 0.875rem;
          gap: 24px;
          font-weight: 500;
        }

        .meta-item {
          gap: 6px;
        }

        .meta-icon {
          font-size: 13px;
          color: #9ca3af;
        }

        /* Image principale */
        .blog-featured-image {
          margin-bottom: 3rem;
          border-radius: 12px;
         
        }

        .blog-featured-image img {
          width: 80%;
          height: 600px;
        }

        /* Extrait */
        .blog-excerpt .lead {
          font-family: 'Merriweather', Georgia, serif;
          font-size: 1.35rem;
          font-weight: 400;
          line-height: 1.7;
          color: #374151;
          border-left: 4px solid #198754;
          padding-left: 1.5rem;
          margin-bottom: 2.5rem;
        }

        /* Contenu du blog */
        .blog-body {
          font-size: 1.0625rem;
          line-height: 1.8;
          color: #1f2937;
          text-align: justify;
        }

        .blog-body h3 {
          font-family: 'Inter', sans-serif;
          margin-top: 3.5rem;
          margin-bottom: 1.25rem;
          font-weight: 700;
          font-size: 1.75rem;
          color: #111827;
          letter-spacing: -0.01em;
        }

        .blog-body h3.errors-section-title {
          position: relative;
          padding: 1.25rem 0;
          margin-top: 4rem;
          margin-bottom: 2.5rem;
        }

        .blog-body h3.errors-section-title::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          width: 60px;
          height: 4px;
          background: linear-gradient(90deg, #dc3545, #198754);
          border-radius: 2px;
        }
        
        .blog-body h4 {
          margin-top: 1.75rem;
          margin-bottom: 1rem;
          font-weight: 600;
          font-size: 1.1rem;
          color: #1f2937;
        }

        .blog-body p {
          margin-bottom: 1.5rem;
        }
        
        .blog-body ul {
          margin-bottom: 2rem;
          padding-left: 1.5rem;
        }
        
        .blog-body li {
          margin-bottom: 1rem;
          padding-left: 0.5rem;
        }

        .blog-body li strong {
          color: #198754;
          font-weight: 600;
        }

        .blog-body blockquote {
          border-left: 4px solid #198754;
          padding: 1.5rem 1.5rem 1.5rem 2rem;
          margin: 2.5rem 0;
          color: #374151;
          background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
          border-radius: 0 8px 8px 0;
          font-style: normal;
          font-weight: 500;
          box-shadow: 0 2px 12px rgba(25, 135, 84, 0.08);
        }

        /* Cartes d'erreur - MISE EN EXERGUE */
        .blog-body .error-card {
          background: #ffffff;
          border: 2px solid #fee2e2;
          border-left: 5px solid #dc3545;
          border-radius: 10px;
          padding: 2rem;
          margin: 2rem 0;
          box-shadow: 0 4px 16px rgba(220, 53, 69, 0.12);
          transition: all 0.3s ease;
          position: relative;
        }

        .blog-body .error-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 24px rgba(220, 53, 69, 0.18);
          border-color: #fecaca;
        }

        .blog-body .error-card::before {
          content: '⚠';
          position: absolute;
          top: -15px;
          right: 25px;
          font-size: 2rem;
          background: #fff;
          width: 45px;
          height: 45px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 2px 8px rgba(220, 53, 69, 0.2);
        }

        .blog-body .error-card h4 {
          color: #991b1b;
          font-size: 1.2rem;
          font-weight: 700;
          margin-top: 0;
          margin-bottom: 1rem;
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }

        .blog-body .error-card .error-number {
          background: linear-gradient(135deg, #dc3545, #b91c1c);
          color: white;
          padding: 4px 14px;
          border-radius: 20px;
          font-size: 0.85rem;
          font-weight: 700;
          letter-spacing: 0.02em;
          white-space: nowrap;
        }

        .blog-body .error-card p {
          margin-bottom: 1rem;
          color: #374151;
        }

        .blog-body .error-card .solution {
          background: linear-gradient(135deg, #f0fdf4, #dcfce7);
          border-left: 3px solid #198754;
          padding: 1rem 1.25rem;
          margin: 1.25rem 0 0 0;
          border-radius: 6px;
          font-size: 0.975rem;
        }

        .blog-body .error-card .solution strong {
          color: #065f46;
        }

        /* Tags */
        .blog-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 3rem;
          padding-top: 2rem;
          border-top: 1px solid #e5e7eb;
        }

        .blog-tag {
          display: inline-block;
          background-color: #f3f4f6;
          color: #6b7280;
          padding: 6px 15px;
          border-radius: 20px;
          text-decoration: none;
          font-size: 0.8125rem;
          font-weight: 500;
          transition: all 0.2s ease;
          border: 1px solid transparent;
        }

        .blog-tag:hover {
          background-color: #198754;
          color: white;
          border-color: #198754;
          transform: translateY(-2px);
        }

        /* Partage social */
        .blog-share {
          margin-top: 2.5rem;
          padding-top: 2rem;
          border-top: 1px solid #e5e7eb;
        }

        .share-title {
          font-size: 0.9375rem;
          margin-bottom: 1rem;
          color: #6b7280;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        .social-buttons {
          display: flex;
          gap: 12px;
        }

        .social-button {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          text-decoration: none;
          transition: all 0.3s ease;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }

        .social-button:hover {
          transform: translateY(-4px);
          box-shadow: 0 6px 16px rgba(0,0,0,0.15);
        }

        .linkedin {
          background-color: #0077B5;
        }

        .twitter {
          background-color: #1DA1F2;
        }

        .facebook {
          background-color: #4267B2;
        }

        /* Bouton retour */
        .btn-back {
          display: inline-flex;
          align-items: center;
          background-color: #ffffff;
          color: #374151;
          padding: 12px 24px;
          border-radius: 8px;
          text-decoration: none;
          border: 1px solid #e5e7eb;
          transition: all 0.2s ease;
          font-weight: 500;
          font-size: 0.9375rem;
        }

        .btn-back:hover {
          background-color: #f9fafb;
          border-color: #198754;
          color: #198754;
          transform: translateX(-5px);
        }

        /* Sidebar Widgets */
        .sidebar-widget {
          background-color: #ffffff;
          border-radius: 12px;
          padding: 2rem;
          margin-bottom: 1.75rem;
          border: 1px solid #f3f4f6;
          box-shadow: 0 1px 3px rgba(0,0,0,0.05);
        }

        .widget-title {
          font-size: 1.125rem;
          margin-bottom: 1.5rem;
          padding-bottom: 0.75rem;
          border-bottom: 2px solid #f3f4f6;
          position: relative;
          font-weight: 700;
          color: #111827;
        }

        .widget-title:after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 50px;
          height: 2px;
          background: #198754;
        }

        /* Widget Auteur */
        .author-profile {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
        }

        .author-image {
          width: 90px;
          height: 90px;
          border-radius: 50%;
          overflow: hidden;
          margin-bottom: 1rem;
          border: 3px solid #198754;
        }
        .author-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .author-name {
          font-size: 1.125rem;
          font-weight: 700;
          margin-bottom: 0.25rem;
          color: #111827;
        }
        .author-title {
          font-size: 0.875rem;
          color: #6b7280;
          margin-bottom: 1rem;
          font-weight: 500;
        }
        .author-bio {
          font-size: 0.875rem;
          color: #4b5563;
          line-height: 1.6;
        }
        /* Widget Articles Similaires */
        .similar-blogs .similar-blog {
          display: flex;
          margin-bottom: 1.5rem;
          text-decoration: none;
          color: inherit;
          transition: all 0.2s ease;
        }
        .similar-blogs .similar-blog:hover {
          transform: translateX(-5px);
        }
        .similar-blog-image {
          position: relative;
          width: 80px;
          height: 80px;
          flex-shrink: 0;
          border-radius: 8px;
          overflow: hidden;
          margin-right: 1rem;
        }
        .similar-blog-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .similar-blog-image .category-badge.small {
          position: absolute;
          top: 8px;
          left: 8px;
          font-size: 0.625rem;
          padding: 3px 10px;
        }
        .similar-blog-content {
          flex: 1;
        }
        .similar-blog-title {
          font-size: 1rem;
          font-weight: 600;
          margin-bottom: 0.25rem;
          color: #111827;
        }
        .similar-blog-date {
          display: flex;
          align-items: center;
          color: #6b7280;
          font-size: 0.8125rem;
          gap: 4px;
        }
        /* Widget Newsletter */
        .newsletter-desc {
          font-size: 0.875rem;
          color: #4b5563;
          margin-bottom: 1rem;
          line-height: 1.6;
        }
        .newsletter-form .form-control {
          border-radius: 8px;
          border: 1px solid #d1d5db;
          padding: 10px 15px;
          font-size: 0.875rem;
          transition: border-color 0.2s;
        }
        .newsletter-form .form-control:focus {
          border-color: #198754;
          box-shadow: 0 0 0 3px rgba(25, 135, 84, 0.2);
          outline: none;
        }
        .newsletter-form .btn {
          border-radius: 8px;
          font-size: 0.9375rem;
          font-weight: 600;
        }
        .newsletter-form .btn:hover {
          background-color: #157347;
          border-color: #157347;
        }

        /* Widget Catégories */
        .categories-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .categories-list li {
          margin-bottom: 1rem;
        }
        .categories-list li a {
          text-decoration: none;
          color: #374151;
          font-size: 0.9375rem;
          font-weight: 500;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: color 0.2s;
        }
        .categories-list li a:hover {
          color: #198754;
        }
        .categories-list li a span {
          font-size: 1.25rem;
          line-height: 1;
        }
        /* Responsive */
        @media (max-width: 991.98px) {
          .blog-title {
            font-size: 2.25rem;
          }
        }
        @media (max-width: 767.98px) {
          .blog-title {
            font-size: 1.875rem;
          }
          .blog-body h3 {
            font-size: 1.5rem;
            margin-top: 2.5rem;
            margin-bottom: 1rem;
          }
          .blog-body h3.errors-section-title::before {
            width: 40px;
          }
          .blog-body h4 {
            font-size: 1rem;
          }
          .blog-body .error-card {
            padding: 1.5rem;
          }
          .blog-body .error-card h4 {
            font-size: 1.1rem;
          }
          .blog-body .error-card .error-number {
            font-size: 0.75rem;
            padding: 3px 12px;
          }
          .blog-body .error-card .solution {
            font-size: 0.9rem;
            padding: 0.75rem 1rem;
          }
          .blog-excerpt .lead {
            font-size: 1.125rem;
          }
          .meta-item span {
            font-size: 0.8125rem;
          }
          .meta-icon {
            font-size: 12px;
          }
          .similar-blog-image {
            width: 70px;
            height: 70px;
          }
          .similar-blog-title {
            font-size: 0.95rem;
          }
          .similar-blog-date {
            font-size: 0.75rem;
          }
          .author-image {
            width: 80px;
            height: 80px;
            margin-bottom: 0.75rem;
          }
          .author-name {
            font-size: 1rem;
          }
          .author-title {
            font-size: 0.8125rem;
          }
        }
        @media (max-width: 575.98px) {
          .blog-body h3 {
            font-size: 1.25rem;
            margin-top: 2rem;
            margin-bottom: 0.75rem;
          }
          .blog-body h3.errors-section-title::before {
            width: 30px;
          }
          .blog-body h4 {
            font-size: 0.95rem;
          }
          .blog-body .error-card h4 {
            font-size: 1rem;
          }
          .blog-body .error-card .error-number {
            font-size: 0.7rem;
            padding: 2px 10px;
          }
          .blog-body .error-card .solution {
            font-size: 0.875rem;
            padding: 0.5rem 0.75rem;
          }
          .blog-excerpt .lead {
            font-size: 1rem;
          }
          .meta-item span {
            font-size: 0.75rem;
          }
          .meta-icon {
            font-size: 11px;
          }
          .similar-blog-image {
            width: 60px;
            height: 60px;
            margin-right: 0.75rem;
          }
          .similar-blog-title {
            font-size: 0.9rem;
            margin-bottom: 0.15rem;
          }
          .similar-blog-date {
            font-size: 0.7rem;
          }
          .author-image {

            width: 70px;
            height: 70px;
            margin-bottom: 0.5rem;
          } 
          .author-name {
            font-size: 0.95rem;
          }
          .author-title {
            font-size: 0.75rem;
          }
        }
      `}</style>
        </>
    );
};
export default DetailBlog2;